import Vue from "vue";
import VueI18n from "vue-i18n";
import vuetify from "@/plugins/vuetify.js";
import axios from "axios";
import {
  getBrowserLocale,
  supportedLocalesInclude
} from "app/tools/i18nUtils.js";
import numberFormats from "app/locales/numberFormats.js";
import dateTimeFormats from "app/locales/datetimeFormats.js";
import pluralizationRules from "app/locales/pluralizationRules.js";

export const I18N_LOCALE = "fr";
export const I18N_FALLBACK_LOCALE = "fr";

Vue.use(VueI18n);

const getStartingLocale = () => {
  const storedLocale = localStorage.getItem("lang");

  if (storedLocale) {
    return storedLocale;
  }

  const browserLocale = getBrowserLocale({ countryCodeOnly: true });

  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale;
  }

  return I18N_LOCALE;
};

const startingLocale = getStartingLocale();

const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: startingLocale,
  fallbackLocale: I18N_FALLBACK_LOCALE,
  messages: {},
  dateTimeFormats,
  numberFormats,
  pluralizationRules
});

const loadedLanguages = [];

export const loadLocaleMessagesAsync = async locale => {
  if (loadedLanguages.length > 0 && i18n.locale === locale) {
    return Promise.resolve(locale);
  }

  if (loadedLanguages.includes(locale)) {
    i18n.locale = locale;
    vuetify.framework.lang.current = locale;
    axios.defaults.headers.common["Accept-Language"] = locale;

    return Promise.resolve(locale);
  }

  try {
    const messages = await import(
      /* webpackChunkName: "locale-[request]" */ `app/locales/lang/${locale}.json`
    );
    i18n.setLocaleMessage(locale, messages.default);
    loadedLanguages.push(locale);
    i18n.locale = locale;
    vuetify.framework.lang.current = locale;

    return Promise.resolve(locale);
  } catch (error) {
    return Promise.reject("Translation file not found");
  }
};

loadLocaleMessagesAsync(startingLocale);

export const getLocale = locale =>
  locale ? locale : i18n.locale ? i18n.locale : I18N_FALLBACK_LOCALE;

export default i18n;
